/**
 * insightEngine.js
 * Pure function: returns contextual insight keys based on current wizard answers.
 * No React dependencies — fully testable.
 */

/**
 * Returns contextual insights based on current wizard answers.
 * @param {import('../../../modules/mortgageSmartFinder').WizardAnswers} answers
 * @returns {{ key: string, type: 'info'|'tip'|'warning' }[]}
 */
export function getInsights(answers) {
  const insights = [];

  if (answers.province === 'QC') {
    insights.push({ key: 'qc_banks', type: 'tip' });
  }

  const dpPct = answers.price > 0 ? (answers.downPayment / answers.price) * 100 : 0;
  if (dpPct > 0 && dpPct < 20) {
    insights.push({ key: 'cmhc_applies', type: 'info' });
  }
  if (dpPct >= 20) {
    insights.push({ key: 'no_cmhc', type: 'tip' });
  }

  if (['pr', 'work_permit', 'newcomer_2y'].includes(answers.status)) {
    insights.push({ key: 'newcomer_programs', type: 'tip' });
  }

  if (answers.status === 'student') {
    insights.push({ key: 'student_limited', type: 'warning' });
  }

  if (answers.credit === 'no' || answers.credit === 'unsure') {
    insights.push({ key: 'credit_building', type: 'info' });
  }

  if (answers.price > 1000000) {
    insights.push({ key: 'not_insurable', type: 'warning' });
  }

  if (answers.offerAccepted === true) {
    insights.push({ key: 'rate_hold_important', type: 'info' });
  }

  return insights;
}
